/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommContentTemplate5Data } from './ecomm-content-template-5.data';
import { IEcommContentTemplate5Props } from './ecomm-content-template-5.props.autogenerated';

export interface IEcommContentTemplate5ViewProps extends IEcommContentTemplate5Props<IEcommContentTemplate5Data> {
    description: React.ReactNode;
}

/**
 *
 * EcommContentTemplate5 component
 * @extends {React.PureComponent<IEcommContentTemplate5Props<IEcommContentTemplate5Data>>}
 */
class EcommContentTemplate5 extends React.PureComponent<IEcommContentTemplate5Props<IEcommContentTemplate5Data>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const text = config.description && (
            <MsDyn365.RichTextComponent
                text={config.description}
                editProps={{
                    onEdit: this._handleTextChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const EcommContentTemplateViewProps = {
            ...this.props,
            description: text
        };

        return this.props.renderView(EcommContentTemplateViewProps);
    }

    private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);
}

export default EcommContentTemplate5;
